import { Button } from 'seagull';
import { COBStep, getNextStepButtonText, getStepName } from "../ClientOnboarding.utils";
import { IntroVideo, IntroVideoTestIds } from "../ClientOnboardingInnerV2/OnboardingPage/Steps/IntroVideoStep/IntroVideo";
import { useCobConfig } from "../CobConfigContext";
import { StepPage } from "../../components/StepPage";
import { jsx as _jsx } from "react/jsx-runtime";
export { IntroVideoTestIds as IntroVideoStepTestIds };
const IntroVideoStep = _ref => {
  let {
    onDone,
    onBack
  } = _ref;
  const {
    relationship
  } = useCobConfig();
  return /*#__PURE__*/_jsx(StepPage, {
    header: getStepName(COBStep.introVideo, relationship),
    dataTestId: IntroVideoTestIds.Root(),
    primaryBtn: /*#__PURE__*/_jsx(Button, {
      "data-testid": IntroVideoTestIds.PrimaryNextButton(),
      onClick: onDone,
      children: getNextStepButtonText(COBStep.introVideo, relationship)
    }),
    onBackBtnClick: onBack,
    children: /*#__PURE__*/_jsx(IntroVideo, {})
  });
};
export default IntroVideoStep;